import {SegmentationDto} from './SegmentationDto';
import {ISegmentationDto} from './SegmentationDtoInterface';
import ISegmentationListDto, {DataToSent} from './SegmentationListDtoInterface';

export class SegmentationListDto implements ISegmentationListDto {
  private _segmentations: Map<string, ISegmentationDto>;

  constructor() {
    this._segmentations = new Map();
  }

  static fromJSON(data: any): SegmentationListDto {
    const list = new SegmentationListDto();

    if (data.segmentations) {
      const segmentationsObj = data.segmentations;

      Object.keys(segmentationsObj).forEach(imageId => {
        const segmentationData = segmentationsObj[imageId];
        const segmentation = SegmentationDto.fromJSON(segmentationData);

        list.addOrUpdateSegmentation(imageId, segmentation);
      });
    }

    return list;
  }

  toJSON() {
    const segmentationsObj: {[key: string]: any} = {};

    this._segmentations.forEach((segmentation, imageId) => {
      segmentationsObj[imageId] = segmentation.toJSON();
    });

    return {
      segmentations: segmentationsObj,
    };
  }

  getDataToSent(): DataToSent[] {
    return this.getAllSegmentations().map(segmentation =>
      JSON.parse(
        JSON.stringify({
          image_id: segmentation.imageId,
          polygons: segmentation.data.polygons,
        })
      )
    );
  }

  addOrUpdateSegmentation(imageId: string, segmentation?: ISegmentationDto): void {
    if (segmentation) {
      this._segmentations.set(imageId, segmentation);
    } else if (!this._segmentations.has(imageId)) {
      this._segmentations.set(imageId, new SegmentationDto(imageId));
    }
  }

  removeSegmentation(imageId: string): boolean {
    return this._segmentations.delete(imageId);
  }

  getSegmentationByImageId(imageId: string): ISegmentationDto | undefined {
    return this._segmentations.get(imageId);
  }

  getAllSegmentations(): ISegmentationDto[] {
    return Array.from(this._segmentations.values());
  }

  clone(): ISegmentationListDto {
    const clone = new SegmentationListDto();

    this._segmentations.forEach((segmentation, imageId) => {
      clone.addOrUpdateSegmentation(imageId, new SegmentationDto(imageId, segmentation));
    });

    return clone;
  }

  toString(): string {
    return `SegmentationList: ${this._segmentations.size} segmentations`;
  }
}
